/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AiLogPageComponent } from "@src/app/modules/crm/ai-log-page/ai-log-page.component";
import { currentPeriod } from "@src/app/modules/crm/request-analysis/analysis-period";
import { ChartParms } from "@src/app/model/sys/nav-item";
import { NavRoute } from "@src/app/shared/NavRoute";

export const AiLogPageNavRoute = new NavRoute('crm/aiLogs', () => AiLogPageComponent, 'smart_toy')
    .setCharts([
        { type: 'pie', picklist: 'month', sortBy: 'id' } as ChartParms,
        { type: 'pie', picklist: 'outcome', showOnly: 0 } as ChartParms,
        { type: 'bar', picklist: 'teamId' } as ChartParms,
    ])
    .setViews(() => [
        {
            id: 'all',
            name: $localize`Everything Asked`,
            helpText: 'Every question put to the AI assistant, including those answered automatically',
            filterFields: { outcome: 'ANY', month: currentPeriod('month') },
        },
        {
            id: 'reviewed',
            name: $localize`Reviewed Answers`,
            helpText: 'Answers our AI assistant gave that someone has accepted, changed or rejected',
            filterFields: { outcome: 'accepted,changed,rejected', month: currentPeriod('month') },
        },
        {
            id: 'pending',
            name: $localize`Waiting For Review`,
            helpText: 'Answers the assistant has drafted that nobody has looked at yet',
            filterFields: { outcome: 'pending', month: currentPeriod('month') },
        },
    ]);
